import React from 'react';
import { Box, Typography } from '@mui/material';
import { ThemeProvider } from '@mui/material';
import { theme } from '../../../theme';

const Invoice: React.FC<{ invoiceData: any }> = ({ invoiceData }) => {
  console.log('Invoice Data:', invoiceData);
  if (!invoiceData) return null;

  // Format date nicely
  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getDisplayValue = (value: any) => {
    if (typeof value === 'object' && value !== null && ('en' in value || 'ar' in value)) {
      return value.en || value.ar || '';
    }
    return value ?? '-';
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        style={{
          border: '1px solid #ddd',
          borderRadius: 5,
          padding: 16,
          background: '#fff',
          fontFamily: 'inherit',
        }}
      >
        <Box
          style={{
            borderBottom: '1px solid #eee',
            marginBottom: 16,
            paddingBottom: 8,
          }}
        >
          <Typography style={{ margin: 0, fontWeight: 400 }}>
            Invoice Details
          </Typography>
        </Box>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: 16,
          }}
        >
          <Box>
            <Typography
              style={{
                fontSize: 32,
                color: '#aaa',
                fontWeight: 300,
                marginBottom: 8,
              }}
            >
              To
            </Typography>
            <Typography style={{ fontWeight: 600 }}>
              {getDisplayValue(invoiceData.customerName) || getDisplayValue(invoiceData.invoice?.billingTo?.name)}
            </Typography>
            <Typography>
              Address : {getDisplayValue(invoiceData.shippingAddress?.addressLine) || '-'}
            </Typography>
            <Typography>
              Phone : {getDisplayValue(invoiceData.shippingAddress?.phoneNumber) || '-'}
            </Typography>
          </Box>
          <Box style={{ minWidth: 280 }}>
            <Box style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
              <Typography style={{ fontWeight: 600, minWidth: 140 }}>
                Order placed on:
              </Typography>
              <Typography style={{ fontWeight: 400, textAlign: 'right' }}>
                {formatDate(invoiceData.orderDate)}
              </Typography>
            </Box>
            <Box style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
              <Typography style={{ fontWeight: 600, minWidth: 140 }}>
                Order ID:
              </Typography>
              <Typography style={{ fontWeight: 400, textAlign: 'right' }}>
                {invoiceData.orderNumber}
              </Typography>
            </Box>
            <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography style={{ fontWeight: 600, minWidth: 140 }}>
                Payment Status:
              </Typography>
              <Typography style={{ fontWeight: 400, textAlign: 'right' }}>
                {invoiceData.paymentStatus || '-'}
              </Typography>
            </Box>
          </Box>
        </Box>
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginBottom: 24,
            background: '#fafafa',
            tableLayout: 'fixed',
          }}
        >
          <thead>
            <tr style={{ background: '#f5f5f5' }}>
              <th
                style={{
                  padding: 8,
                  border: '1px solid #eee',
                  textAlign: 'left',
                  width: '20%',
                }}
              >
                <Typography style={{ fontWeight: 500 }}>
                  Restaurant Name
                </Typography>
              </th>
              <th
                style={{
                  padding: 8,
                  border: '1px solid #eee',
                  textAlign: 'left',
                  width: '15%',
                }}
              >
                <Typography style={{ fontWeight: 500 }}>Item</Typography>
              </th>
              <th
                style={{
                  padding: 8,
                  border: '1px solid #eee',
                  textAlign: 'left',
                  width: '12%',
                }}
              >
                <Typography style={{ fontWeight: 500 }}>
                  Pre order date
                </Typography>
              </th>
              <th
                style={{
                  padding: 8,
                  border: '1px solid #eee',
                  textAlign: 'left',
                  width: '8%',
                }}
              >
                <Typography style={{ fontWeight: 500 }}>Quantity</Typography>
              </th>
              <th
                style={{
                  padding: 8,
                  border: '1px solid #eee',
                  textAlign: 'left',
                  width: '12%',
                }}
              >
                <Typography style={{ fontWeight: 500 }}>Unit Price</Typography>
              </th>
              <th
                style={{
                  padding: 8,
                  border: '1px solid #eee',
                  textAlign: 'left',
                  width: '12%',
                }}
              >
                <Typography style={{ fontWeight: 500 }}>Discounted Price</Typography>
              </th>
              <th
                style={{
                  padding: 8,
                  border: '1px solid #eee',
                  textAlign: 'left',
                  width: '10%',
                }}
              >
                <Typography style={{ fontWeight: 500 }}>Tax</Typography>
              </th>
              <th
                style={{
                  padding: 8,
                  border: '1px solid #eee',
                  textAlign: 'left',
                  width: '11%',
                }}
              >
                <Typography style={{ fontWeight: 500 }}>Sub Total</Typography>
              </th>
            </tr>
          </thead>
          <tbody>
            {invoiceData.orderItems?.map((item: any, idx: number) => {
              const originalPrice = item.originalPrice ?? null;
              const discountedPrice = item.discountedPrice ?? null;
              const effectiveUnit = discountedPrice ?? originalPrice;
              const quantity = Number(item.quantity || 0);
              const lineTax = item.costBreakdown?.tax != null ? Number(item.costBreakdown.tax) : null;
              const computedSubTotal = effectiveUnit != null ? (Number(effectiveUnit) * quantity) : null;
              return (
              <tr key={idx}>
                <td style={{ padding: 8, border: '1px solid #eee' }}>
                  <Typography>{getDisplayValue(item.storeName) || '-'}</Typography>
                  {/* If you have address and phone for store, add here */}
                </td>
                <td style={{ padding: 8, border: '1px solid #eee' }}>
                  <Typography>{getDisplayValue(item.itemName) || '-'}</Typography>
                </td>
                <td style={{ padding: 8, border: '1px solid #eee' }}>
                  <Typography>{item.preOrderDate || '-'}</Typography>
                </td>
                <td style={{ padding: 8, border: '1px solid #eee' }}>
                  <Typography>{item.quantity || '-'}</Typography>
                </td>
                <td style={{ padding: 8, border: '1px solid #eee' }}>
                  <Typography>
                    {originalPrice != null ? `JOD ${originalPrice}` : '-'}
                  </Typography>
                </td>
                <td style={{ padding: 8, border: '1px solid #eee' }}>
                  <Typography>
                    {discountedPrice != null ? `JOD ${discountedPrice}` : '-'}
                  </Typography>
                </td>
                <td style={{ padding: 8, border: '1px solid #eee' }}>
                  <Typography>{lineTax != null ? `JOD ${lineTax}` : '-'}</Typography>
                </td>
                <td style={{ padding: 8, border: '1px solid #eee' }}>
                  <Typography>
                    {computedSubTotal != null ? `JOD ${computedSubTotal.toFixed(2)}` : (item.costBreakdown?.subTotal ? `JOD ${item.costBreakdown.subTotal}` : '-')}
                  </Typography>
                </td>
              </tr>
              );
            })}
          </tbody>
        </table>
        <Typography style={{ marginBottom: 24, fontSize: 18 }}>
          Payment Methods :{' '}
          <span style={{ fontWeight: 400 }}>
            {invoiceData.paymentMethod || 'COD'}
          </span>
        </Typography>
        <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <table
            style={{
              minWidth: 350,
              borderCollapse: 'collapse',
              background: '#fafafa',
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    padding: 8,
                    border: '1px solid #eee',
                    fontWeight: 600,
                  }}
                >
                  <Typography>Sub Total (+) :</Typography>
                </td>
                <td
                  style={{
                    padding: 8,
                    border: '1px solid #eee',
                    textAlign: 'right',
                  }}
                >
                  <Typography>
                    {invoiceData.invoiceDetails?.subTotal
                      ? `JOD ${invoiceData.invoiceDetails.subTotal}`
                      : '-'}
                  </Typography>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    padding: 8,
                    border: '1px solid #eee',
                    fontWeight: 600,
                  }}
                >
                  <Typography>Tax (+) :</Typography>
                </td>
                <td
                  style={{
                    padding: 8,
                    border: '1px solid #eee',
                    textAlign: 'right',
                  }}
                >
                  <Typography>
                    {invoiceData.invoiceDetails?.tax != null ? `JOD ${Number(invoiceData.invoiceDetails.tax).toFixed(2)}` : '-'}
                  </Typography>
                </td>
              </tr>
              {invoiceData.invoiceDetails?.deliveryFee != null && 
               invoiceData.invoiceDetails.deliveryFee !== 0 && (
                <tr>
                  <td
                    style={{
                      padding: 8,
                      border: '1px solid #eee',
                      fontWeight: 600,
                    }}
                  >
                    <Typography>Delivery Fee (+) :</Typography>
                  </td>
                  <td
                    style={{
                      padding: 8,
                      border: '1px solid #eee',
                      textAlign: 'right',
                    }}
                  >
                    <Typography>
                      JOD {invoiceData.invoiceDetails.deliveryFee}
                    </Typography>
                  </td>
                </tr>
              )}
              <tr>
                <td
                  style={{
                    padding: 8,
                    border: '1px solid #eee',
                    fontWeight: 600,
                  }}
                >
                  <Typography>Wallet Used (-) :</Typography>
                </td>
                <td
                  style={{
                    padding: 8,
                    border: '1px solid #eee',
                    textAlign: 'right',
                  }}
                >
                  <Typography>
                    {invoiceData.invoiceDetails?.walletUsed
                      ? `JOD ${invoiceData.invoiceDetails.walletUsed}`
                      : '-'}
                  </Typography>
                </td>
              </tr>
              {/* Add Offer Used, Cancelled Item Total if available */}
              <tr>
                <td
                  style={{
                    padding: 8,
                    border: '1px solid #eee',
                    fontWeight: 600,
                  }}
                >
                  <Typography>Offer Used (-) :</Typography>
                </td>
                <td
                  style={{
                    padding: 8,
                    border: '1px solid #eee',
                    textAlign: 'right',
                  }}
                >
                  <Typography>
                    {invoiceData.invoiceDetails?.offerDiscount
                      ? `JOD ${invoiceData.invoiceDetails.offerDiscount}`
                      : 'JOD 0.00 '}
                  </Typography>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    padding: 8,
                    border: '1px solid #eee',
                    fontWeight: 600,
                  }}
                >
                  <Typography>Cancelled Item Total (-) :</Typography>
                </td>
                <td
                  style={{
                    padding: 8,
                    border: '1px solid #eee',
                    textAlign: 'right',
                  }}
                >
                  <Typography>
                    {invoiceData.invoice?.cancelledItemTotal
                      ? `JOD ${invoiceData.invoice.cancelledItemTotal}`
                      : 'JOD 0.00'}
                  </Typography>
                </td>
              </tr>
              <tr
                style={{
                  background: '#f0f0f0',
                  fontWeight: 600,
                }}
              >
                <td
                  style={{
                    padding: 8,
                    border: '1px solid #eee',
                  }}
                >
                  <Typography>Total</Typography>
                </td>
                <td
                  style={{
                    padding: 8,
                    border: '1px solid #eee',
                    textAlign: 'right',
                  }}
                >
                  <Typography>
                    {invoiceData.invoiceAmount
                      ? `JOD ${invoiceData.invoiceAmount}`
                      : '-'}
                  </Typography>
                </td>
              </tr>
            </tbody>
          </table>
        </Box>
        <Box style={{ marginTop: 32 }}>
          <button
            onClick={() => window.print()}
            style={{
              padding: '8px 24px',
              border: '1px solid #bbb',
              borderRadius: 4,
              background: '#fff',
              cursor: 'pointer',
              fontSize: 16,
            }}
          >
            <span role="img" aria-label="print" style={{ marginRight: 8 }}>
              🖨️
            </span>
            Print
          </button>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default Invoice;
